import React, { useState } from 'react'
import { RemittanceApi } from '../../../../api/Sales/Remittances'
import { VouchersApi } from '../../../../api/Purchase/Vouchers'
import useModalShow from '../../../../elements/Hooks/useModalShow'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import useTitle from '../../../../elements/Hooks/useTitle'
import { get, isEmpty, pick, round } from 'lodash'
import useFetchObject from '../../../../elements/Hooks/useFetchObject'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import AddRemittance from '../../../../components/Purchasing/Remittance/AddRemittance/AddRemittance'
import { withRouter } from 'react-router-dom'
import { dateFormat, dateVal, moneyInline, numVal, strVal } from '../../../../modules/Utils'
import DocumentsApi from '../../../../api/Documents'
import Email from '../../../../api/Email'
import Templates from '../../../../api/Templates'
import { message } from 'antd'
import useModalData from '../../../../elements/Hooks/useModalData'

export const AddRemittanceContext = React.createContext({})
const templateApi = new Templates()
const emailApi = new Email()
const docsApi = new DocumentsApi()

function AddRemittanceCont(props) {
  const key = get(props.match, 'params.key')
  const type = key ? 'edit' : 'new'

  const { fetch, fetching, object: remittance, setObject: setRemittance } = useFetchObject(
    () => RemittanceApi.read(key),
    false,
    [key],
    isEmpty(key)
  )

  const { list: actions, fetching: fetchingActions, fetch: fetchActions } = useFetchList(
    () => docsApi.actions('remittance', remittance.status),
    [remittance.status, isEmpty(remittance.status), undefined, undefined, false, true]
  )

  const [submitting, submitFunc] = useSubmit(RemittanceApi.create)
  const [updating, updateFunc] = useSubmit(RemittanceApi.update)

  const {
    visible: visiblePhonebook,
    onShow: onShowPhoneBook,
    onCancel: onCancelPhoneBook,
    isNew,
  } = useModalShow()

  const { formRef } = useModalData(RemittanceApi.create, RemittanceApi.update, fetch)

  // const {
  //   list: remitterList,
  //   fetching: fetchingRemitter,
  //   fetch: fetchRemitter,
  // } = useFetchList(RemittanceApi.remitterList, [visiblePhonebook])

  const [isMemberOrganization, setIsMemberOrganization] = useState(true)
  const [ContactPersonLoading, setContactPersonLoading] = useState(false)
  const [contactPerson, setContactPerson] = useState([])

  const [submittingTemplate, submitTemplate] = useSubmit(templateApi.read, true)
  const [submittingRemittanceTemplate, submitRemittanceTemplate] = useSubmit(
    emailApi.remittanceTemplate,
    true
  )
  const [submittingRemittanceFiles, submitRemittanceFiles] = useSubmit(RemittanceApi.files, true)
  const [gettingListLine, getListLine] = useSubmit(RemittanceApi.getLinesByRemittances, true)
  const [gettingVoucher, getVoucher] = useSubmit(VouchersApi.get, true)

  const [emailOptions, setEmailOptions] = useState({})

  /*const [emailTemplate, setEmailTemplate] = useState('')
  const [emailDetails, setEmailDetails] = useState('')
  const [emailFiles, setEmailFiles] = useState([])
  const [emailLines, setEmailLines] = useState([])*/

  async function showEmail() {
    const emailRemittance = { ...remittance }
    console.log({ emailRemittance })
    if (emailRemittance.status !== 'Confirmed') {
      message.error(`Remittance must be confirmed to email it`)
      return
    }
    const hide = message.loading('Fetching Email Template...', 0)

    try {
      const listLine = await getListLine(remittance._key)
      const voucher = await getVoucher(get(listLine, '[0]voucher._id').replace('vouchers', ''))

      const emailLines = listLine.map((i) => ({
        _id: i._id,
        _key: i._key,
        allocation: moneyInline(round(numVal(i, 'allocation'), 2), strVal(i, 'voucher.currency')),
        ref: strVal(i, 'voucher.orders[0].code'),
        amount: moneyInline(round(numVal(i, 'voucher.amount'), 2), strVal(i, 'voucher.currency')),

        date: dateFormat(dateVal(i, 'voucher.billDate')),
        /*no: i.revision
          ? strVal(i, 'voucher.code') + '.0' + strVal(i, 'voucher.revision')
          : strVal(i, 'voucher.code'),*/
        no: strVal(i, 'voucher.no'),
        //type: strVal(i, 'voucher.type'),
        //title: strVal(i, 'voucher.title'),
        //dueDate: dateFormat(dateVal(i, 'voucher.billDate')),
      }))

      console.log({ emailLines, listLine, voucher })
      const remittanceTemplate = await templateApi.read(
        strVal(emailRemittance, 'from.payor._id').replace('members/', ''),
        'remittance'
      )
      const emailDetails = get(remittanceTemplate, 'email') || {}

      const data = await submitRemittanceTemplate({
        receiver: get(voucher, 'notify.main.fn'),
        lines: emailLines,
        ...emailDetails,
      })
      const filesList = await submitRemittanceFiles([remittance._id])
      const filesMapped = filesList.map((f) => f.uuid)
      const notifyMain = get(voucher, 'notify.main.email.label')
      const notifyAdditional = get(voucher, 'notify.additional')
      const to = notifyMain ? `${notifyMain} ${notifyAdditional ? ',' + notifyAdditional : ''}` : ''

      setEmailOptions({
        visibleEmail: true,
        emailTemplate: data.html,
        fetchingEmailTemplate: false,
        emailFiles: filesList,
        emailLines: emailLines,
        emailDetails: {
          to: to,
          cc: get(emailDetails, 'bcc'),
          bcc: get(emailDetails, 'bcc'),
          from: get(emailDetails, 'from'),
          subject: `[${get(emailRemittance, 'code')}] ${get(emailDetails, 'subject')}`,
          attachments: filesMapped,
        },
      })
      hide()
    } catch (e) {
      hide()
      //console.log(e)
      message.error(e.errorMessage)
      setEmailOptions({
        fetchingEmailTemplate: false,
      })
    }
  }

  function onCancelEmail() {
    setEmailOptions({
      visibleEmail: false,
      emailDetails: {},
      selection: [],
    })
  }

  useTitle(type === 'new' ? `Create New Remittance` : `${remittance.code} Remittance`)

  const [submittingOperation, submitOperation] = useSubmit(RemittanceApi.operation)
  const [removing, removeFunc] = useSubmit(RemittanceApi.remove)

  async function handleActions(operation) {
    let hide = message.loading('', 0)
    if (operation === 'remove') {
      const removed = await removeFunc({
        ...pick(remittance, ['_key', '_rev', '_id']),
      })
      if (removed)
        props.history.replace({
          pathname: `/purchasing/remittance/`,
          hash: 'remittance',
        })
    } else {
      if (operation === 'confirm') {
        try {
          await checkForm()
        } catch (e) {
          hide()
          return
        }
      }
      const ObjectDB = await submitOperation({
        status: operation,
        ...pick(remittance, ['_key', '_rev', '_id']),
      })

      if (ObjectDB) setRemittance(ObjectDB)
    }
    hide()
  }

  function checkForm() {
    return new Promise((res, rej) => {
      formRef.current.validateFieldsAndScroll((err, values) => {
        if (!err) {
          res(values)
        } else rej(err)
      })
    })
  }

  async function update() {
    const values = await checkForm()
    const remittanceDB = await updateFunc({
      ...pick(remittance, ['_key', '_id', '_rev']),
      ...values,
    })
    if (remittanceDB) setRemittance(remittanceDB)
  }

  const { list: lines, fetching: fetchingLines, fetch: fetchLines } = useFetchList(
    () => RemittanceApi.getLinesByRemittances(remittance._key),
    [remittance._rev]
  )

  const {
    visible,
    modalType,
    object: line,
    submitting: submittingLine,
    setSubmitting,
    removing: removingLine,
    remove: removeLine,
    formRef: formRefLine,
    onShow,
    onCancel,
    checkForm: checkFormLine,
    update: updateLine,
  } = useModalData(undefined, RemittanceApi.lines.update, RemittanceApi.lines.remove, fetch)

  async function submitLine() {
    const newObject = await checkFormLine()
    setSubmitting(true)
    try {
      await RemittanceApi.lines.create({
        ...newObject,
        remittance: remittance._key,
      })
      onCancel()
      fetchLines()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  /*useTitle(
    type === 'new' ? `Create New Remittance` : `${remittance.code} Remittance`,
  )*/
  //const isNew = type === 'new'

  return (
    <AddRemittanceContext.Provider
      value={{
        ...emailOptions,
        type,
        isNew,
        fetch,
        fetching,
        remittance,
        setRemittance,
        actions,
        fetchingActions,
        fetchActions,
        showEmail,
        onCancelEmail,
        handleActions,
        update,
        updating,
        formRef,
        // lines
        lines,
        fetchingLines,
        fetchLines,
        visible,
        modalType,
        line,
        submittingLine,
        removingLine,
        onShow,
        onCancel,
        checkFormLine,
        updateLine,
        submitLine,
        removeLine,
        formRefLine,
      }}>
      <AddRemittance />
    </AddRemittanceContext.Provider>
  )
}

export default withRouter(AddRemittanceCont)
